import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { useApplicationContext } from 'shared/context/ApplicationContext';
import { getCancellationTokenFromSignal } from 'shared/utils/getCancellationTokenFromSignal';

import { QueryError, QueryKey, getQueryKey } from './internal/config';
import { fetchGetModerationComplainMicrofrontendService } from './internal/fetchService';

type UseGetModerationComplainMicrofrontendQueryOptions<TData> = UseQueryOptions<
  IMicrofrontendManifest,
  QueryError,
  TData,
  QueryKey
>;

export function useGetModerationComplainMicrofrontendQuery<TData = IMicrofrontendManifest>(
  options?: UseGetModerationComplainMicrofrontendQueryOptions<TData>,
): UseQueryResult<TData, QueryError> {
  const applicationContext = useApplicationContext();

  return useQuery<IMicrofrontendManifest, QueryError, TData, QueryKey>({
    queryFn: ({ signal }) =>
      fetchGetModerationComplainMicrofrontendService({
        applicationContext,
        cancellationToken: getCancellationTokenFromSignal(signal),
      }),
    queryKey: getQueryKey(),
    ...options,
  });
}
